<template>
  <fragment>
    <span>
      {{ $t(option.text) }}
    </span>

    <b-badge v-if="nb">
      {{ nb }}
    </b-badge>
  </fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'

export default {
  components: {
    Fragment
  },

  props: {
    option: Object,
    nb: [Number, Boolean]
  }
}
</script>
